<template>
  <v-master>
    <div class="py-14 sm:pt-20 sm:pb-36 relative">
      <div class="container max-w-sm">
        <a
          class="block mb-10"
          href="https://carbonii.com/"
        >
          <img
            src="/img/icons/svg/logo-login.svg"
            alt="Carbonii"
            class="mx-auto"
          >
        </a>

        <v-form
          :data="form"
          url="/forgot-password"
          method="post"
          @success="emailSent = true"
        >
          <v-input
            v-model="form.email"
            type="email"
            name="email"
            class="mb-5"
            required
            icon="email"
            placeholder="Email"
            input-class="w-full"
          />
          <button
            type="submit"
            class="btn btn-primary w-full mt-5"
          >
            Send link
          </button>
        </v-form>

        <div
          v-if="emailSent"
          class="px-4 py-3 mt-5 text-teal-700 bg-blue-100 border-t border-b border-teal-500"
          role="alert"
        >
          <p class="text-sm">
            We have emailed your password reset link!
          </p>
        </div>
      </div>
    </div>
  </v-master>
</template>
<script>
export default {
  data() {
    return {
      form: {
        email: null
      },
      emailSent: false
    };
  }
};
</script>
